import { useTranslation } from 'react-i18next';
import PricingCard from './PricingCard';

function Pricing() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center py-16 text-white" style={{ background: '#546270' }}>
      <div className="text-4xl mb-12">{t('Pricing.plan')}</div>

      <div className="flex flex-col space-y-20 sm:flex-row sm:space-x-20 sm:space-y-0">
        <PricingCard />

        <PricingCard prefix="member" color="green" />
      </div>
    </div>
  );
}

export default Pricing;
